'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var cx = require('classnames');
var AlloyButton = require('../alloy-button/AlloyButton.js');
var constants = require('../../constants.js');
var utils = require('./utils.js');
var expander_module = require('./expander.module.scss.js');
var useExpander = require('../../hooks/useExpander/useExpander.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var DEFAULT_MAX_HEIGHT = 400;
var HeightLimitedExpander = function (_a) {
    var _b;
    var _c = _a.buttonClassName, buttonClassName = _c === void 0 ? '' : _c, _d = _a.buttonSize, buttonSize = _d === void 0 ? constants.buttonSizes.SMALL : _d, _e = _a.buttonType, buttonType = _e === void 0 ? 'link' : _e, _f = _a.className, className = _f === void 0 ? '' : _f, _g = _a.containsHtml, containsHtml = _g === void 0 ? false : _g, _h = _a.children, children = _h === void 0 ? '' : _h, _j = _a.expanded, expanded = _j === void 0 ? false : _j, _k = _a.hideGradient, hideGradient = _k === void 0 ? false : _k, id = _a.id, lessButtonText = _a.lessButtonText, _l = _a.maxHeight, maxHeight = _l === void 0 ? DEFAULT_MAX_HEIGHT : _l, moreButtonText = _a.moreButtonText, setExpanded = _a.setExpanded;
    var _m = react.useState(false), showButton = _m[0], setShowButton = _m[1];
    var _o = useExpander.useExpander({
        disable: !showButton,
        expanded: expanded,
        minHeight: maxHeight,
        setExpanded: setExpanded
    }), isExpanded = _o.isExpanded, ref = _o.ref, toggle = _o.toggle;
    react.useEffect(function () {
        var determineButtonVisibility = function () {
            var _a, _b;
            var scrollHeight = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) !== null && _b !== void 0 ? _b : maxHeight;
            var buttonVisible = utils.shouldShowButton(scrollHeight, maxHeight);
            setShowButton(buttonVisible);
        };
        determineButtonVisibility();
        window.addEventListener('resize', determineButtonVisibility);
        return function () {
            return window.removeEventListener('resize', determineButtonVisibility);
        };
    }, [maxHeight, ref, toggle]);
    var getContents = function (contentsParam, containsHtmlParam) {
        return typeof contentsParam === 'string' && containsHtmlParam ? (jsxRuntime.jsx("div", { className: "transition-expand", 
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: { __html: contentsParam }, id: id, ref: ref })) : (jsxRuntime.jsx("div", tslib.__assign({ className: "transition-expand", id: id, ref: ref }, { children: contentsParam })));
    };
    var btnWrapperClass = cx__default.default((_b = {
            'd-none': !showButton
        },
        _b[expander_module.default['view-more__btn']] = !hideGradient && !isExpanded,
        _b));
    return (jsxRuntime.jsxs("div", tslib.__assign({ className: cx__default.default('position-relative', className) }, { children: [getContents(children, containsHtml), jsxRuntime.jsx("div", tslib.__assign({ "data-testid": "button-container", className: btnWrapperClass }, { children: jsxRuntime.jsx(AlloyButton.AlloyButton, tslib.__assign({ "aria-expanded": isExpanded, "aria-controls": id, buttonType: buttonType, className: "ps-0 ".concat(buttonClassName), onClick: function () { return toggle(); }, size: buttonSize }, { children: isExpanded ? lessButtonText : moreButtonText })) }))] })));
};
var HeightLimitedExpander$1 = HeightLimitedExpander;

exports.default = HeightLimitedExpander$1;
//# sourceMappingURL=HeightLimitedExpander.js.map
